import React from 'react';
import CopyAgentBlogScript from '../CopyAgentBlogScript/CopyAgentBlogScript';
import GatedBlogsOverlay from './GatedBlogsOverlay';

export default function GatedBlogs() {
	return (
		<section className="relative mb-20">
			<div className="opacity-50 pointer-events-none">
				<CopyAgentBlogScript />
			</div>
			<div className="message-overlay bottom-auto top-20 sm:w-2/3 md:w-1/2">
				<GatedBlogsOverlay />
			</div>
		</section>
	);
}
